
// send event data to GTM
function gtmTrackEvent( category, action, label ) {
    if( !window.dataLayer ) {
        return;
    }

    var event = {
        'event': 'TrackEvent',
        'eventCategory': category,
        'eventAction': action,
        'eventLabel': label
    };

    try {
        dataLayer.push(event);
    } catch (e) {
        console.log(e);
    }
}

window.gtmTrackEvent = gtmTrackEvent;

// send search event data to GTM
function gtmSearchEvent( searchterm ) {
    if( !window.dataLayer || !searchterm ) {
        return;
    }

    var event = {
        'event': 'SearchEvent',
        'eventSearchText': searchterm
    };

    try {
        dataLayer.push(event);
    } catch (e) {
        console.log(e);
    }
}

window.gtmSearchEvent = gtmSearchEvent;